var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "65d04dd6ed60de21ce53dec1d8bcb0f8c0263566"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-ca@rodi"] = {
  id: "65d04dd6ed60de21ce53dec1d8bcb0f8c0263566"
};